export function redirectToUrl(url: string) {
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  if (isSafari) {
    window.location.href = url;
  } else {
    window.open(url, '_self');
  }
}
